import React from 'react'

function FunctionCall() {
    return (
        <span className='cs-exp-func-call'>Function call</span>
    )
}

export { FunctionCall }